export const AGENT_BUILDER_STEP_TITLE: string = 'AGENT_BUILDER.STEP_TITLE';
export const ORGANIZATION_BUILDER_STEP_TITLE: string = 'ORGANIZATION_BUILDER.STEP_TITLE';

export const DAYS_OF_WEEK_LABELS: string[] = [
  'CALENDAR.MON_LABEL',
  'CALENDAR.TUE_LABEL',
  'CALENDAR.WED_LABEL',
  'CALENDAR.THU_LABEL',
  'CALENDAR.FRI_LABEL',
  'CALENDAR.SAT_LABEL',
  'CALENDAR.SUN_LABEL',
];

export const MONTHS_OF_YEAR_LABELS: string[] = [
  'CALENDAR.JAN_LABEL',
  'CALENDAR.FEB_LABEL',
  'CALENDAR.MAR_LABEL',
  'CALENDAR.APR_LABEL',
  'CALENDAR.MAY_LABEL',
  'CALENDAR.JUN_LABEL',
  'CALENDAR.JUL_LABEL',
  'CALENDAR.AUG_LABEL',
  'CALENDAR.SEP_LABEL',
  'CALENDAR.OCT_LABEL',
  'CALENDAR.NOV_LABEL',
  'CALENDAR.DEC_LABEL',
];
